mutation RevokeParticipantPortalAccess($participantId: ID!) {
  revokeParticipantPortalAccess(input: { participantId: $participantId }) {
    errors
  }
}
